// src/components/Layout.js
import React from "react";
import Footer from "./Footer";
import Container from "@mui/material/Container";

const Layout = ({ children, onSignOut, fullWidthSections = [] }) => {
  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      {React.Children.map(children, (child, index) => {
        const isFullWidth = fullWidthSections.includes(index);

        return isFullWidth ? (
          <div style={{ width: "100%" }}>{child}</div>
        ) : (
          <Container component="main" sx={{ pt: 2, flexGrow: 1 }}>
            {child}
          </Container>
        );
      })}
      <Footer />
    </div>
  );
};

export default Layout;
